var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nctaContentContainer",
      style: _vm.nctaContentContainerBackground,
      attrs: { "aria-live": "polite" }
    },
    [
      !_vm.isSubscribed
        ? _c("section", { staticClass: "anonymousIntroContent" }, [
            _c("h3", {
              staticClass: "anonymousHeader",
              style: { color: _vm.settings.accentColor },
              domProps: { innerHTML: _vm._s(_vm.settings.anonymousCopy) }
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.settings.anonymousDescriptionCopy)
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isSubscribed
        ? _c("signup", {
            staticClass: "anonymousSignupContainer",
            attrs: {
              config: _vm.settings,
              "hint-text": _vm.settings.anonymousEmailAddressLabel,
              "legal-copy": _vm.settings.anonymousLegalCopy,
              "enable-expanded-fields": _vm.settings.enableExpandedFields,
              newsletter:
                _vm.newsletters && _vm.newsletters.length > 0
                  ? _vm.newsletters[0]
                  : null
            },
            on: { subscribed: _vm.showThankYou }
          })
        : _c("div", { staticClass: "anonymousThankYouContent" }, [
            _c("h3", {
              style: { color: _vm.settings.accentColor },
              domProps: {
                innerHTML: _vm._s(_vm.settings.anonymousThankYouCopy)
              }
            }),
            _vm._v(" "),
            _c("p", {
              attrs: { role: "status" },
              domProps: {
                innerHTML: _vm._s(_vm.settings.anonymousThankYouDescriptionCopy)
              }
            }),
            _vm._v(" "),
            _vm.regUrl
              ? _c(
                  "a",
                  {
                    staticClass: "anonymousRegister",
                    attrs: { href: _vm.regUrl }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.settings.registrationLinkText) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }